import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { getCopy } from '@/services/tools'

const models = {
  user: {
    role: 'ROLE_USER',
    products: []
  }
}

const state = {
  models,
  users: [],
  user: getCopy(models.user),
  loading: false
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/users/index.js